export default __webpack_public_path__ + "static/media/pnsv_stand_CircuitoExterior.ef2e4210.png";